import type * as React from 'react';
import { del } from '@Domain/Api';
import subjectTypeRestored, {
	type SubjectTypeRestoredAction,
} from '@Application/SubjectTypeDefinitions/Actions/subjectTypeRestored';
import subjectTypeRestoreFailed, {
	type SubjectTypeRestoreFailedAction,
} from '@Application/SubjectTypeDefinitions/Actions/subjectTypeRestoreFailed';
import type RestoreSubjectType from '@Application/SubjectTypeDefinitions/Commands/RestoreSubjectType';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../parameters';

type Actions = SubjectTypeRestoredAction | SubjectTypeRestoreFailedAction;

export default (command: RestoreSubjectType) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			await del<void>(
				`${parameters.api.host}/api/accounts/${command.accountId}/subject-type-definitions/${command.subjectTypeId}/archivals`,
			);

			const action = subjectTypeRestored({ subjectTypeId: command.subjectTypeId }, command.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = subjectTypeRestoreFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
